import { Directive, HostListener, Input } from '@angular/core';

@Directive({
    selector: '[libPreventComma]'
})
export class PreventCommaDirective {
    @Input() appNoCommaReplaceWithDot = false;

    @HostListener('keydown', ['$event'])
    onKeyDown(event: KeyboardEvent) {
        if (event.key === ',') {
            event.preventDefault();
            if (this.appNoCommaReplaceWithDot) {
                const input = event.target as HTMLInputElement;
                if (input.type === 'number') {
                    input.value = (input.value ?? '') + '.';
                    input.dispatchEvent(new Event('input', { bubbles: true }));
                }
            }
        }
    }

    @HostListener('paste', ['$event'])
    onPaste(event: ClipboardEvent) {
        const input = event.target as HTMLInputElement;
        const pasted = event.clipboardData?.getData('text') ?? '';
        const clean = this.sanitize(pasted);

        if (input.type === 'number') {
            setTimeout(() => {
                input.value = this.sanitize(input.value);
                input.dispatchEvent(new Event('input', { bubbles: true }));
            });
            return;
        }

        event.preventDefault();
        this.insertTextAtCursor(input, clean);
    }

    @HostListener('drop', ['$event'])
    onDrop(event: DragEvent) {
        const input = event.target as HTMLInputElement;
        const text = event.dataTransfer?.getData('text') ?? '';
        const clean = this.sanitize(text);

        if (input.type === 'number') {
            event.preventDefault();
            input.value = this.sanitize((input.value ?? '') + clean);
            input.dispatchEvent(new Event('input', { bubbles: true }));
            return;
        }

        event.preventDefault();
        this.insertTextAtCursor(input, clean);
    }

    private sanitize(s: string): string {
        if (this.appNoCommaReplaceWithDot) {
            return s.replace(/,/g, '.');
        }

        return s.replace(/,/g, '');
    }

    private insertTextAtCursor(input: HTMLInputElement, text: string) {
        const start = input.selectionStart ?? input.value.length;
        const end = input.selectionEnd ?? input.value.length;
        const value = input.value ?? '';

        input.value = value.slice(0, start) + text + value.slice(end);

        const newPos = start + text.length;
        try {
            input.setSelectionRange(newPos, newPos);
        } catch {
            // .
        }

        input.dispatchEvent(new Event('input', { bubbles: true }));
    }
}
